import { BaseService } from '@/core/base-service';

export default class QuestionDetailAdminService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/admin/question-detail');
  }
}
